import StatusSigneradIcon from "@/assets/actionIcons/sign.svg";
import StatusBetalningsForbindelse from "@/assets/actionIcons/status_betalningsforbindelse_skickad.svg";
import StatusOffertforfraganEjskickadIcon from "@/assets/actionIcons/status_offertforfragan_ej_skickad.svg";
import StatusOffertforfraganskickadIcon from "@/assets/actionIcons/status_offertforfragan_skickad.svg";
import StatusPrioPreanestesibedomningIcon from "@/assets/actionIcons/status_prio_preanestesi.svg";
import StatusVantarPaHalso from "@/assets/actionIcons/status_vantar_pa_halso.svg";
import StatusAttHanteraIcon from "@/assets/actionIcons/statusatthantera.svg";
import StatusAvbokadIcon from "@/assets/actionIcons/statusavbokad.svg";
import StatusAvvaktanIcon from "@/assets/actionIcons/statusavvaktan.svg";
import StatusBokadIcon from "@/assets/actionIcons/statusbokad.svg";
import StatusGenomfordIcon from "@/assets/actionIcons/statusgenomford.svg";
import StatusKlaropIcon from "@/assets/actionIcons/statusklarop.svg";
import StatusPagaendeIcon from "@/assets/actionIcons/statuspagaende.svg";
import StatusPreanestesibedomningIcon from "@/assets/actionIcons/statuspreanestesibedomning.svg";
import StatusAterkalladIcon from "@/assets/actionIcons/statuspreanestesibedomning/aterkallad.svg";
import StatusAttGoraIcon from "@/assets/actionIcons/statuspreanestesibedomning/att_gora.svg";
import StatusEjGodkandIcon from "@/assets/actionIcons/statuspreanestesibedomning/ej_godkand.svg";
import StatusGodkandIcon from "@/assets/actionIcons/statuspreanestesibedomning/godkand.svg";
import StatusKompletteringUtfordIcon from "@/assets/actionIcons/statuspreanestesibedomning/godkand.svg";
import StatusUtgangenIcon from "@/assets/actionIcons/statuspreanestesibedomning/godkand.svg";
import StatusKompletteringKravsIcon from "@/assets/actionIcons/statuspreanestesibedomning/komplettering_kravs.svg";
import StatusStrukenIcon from "@/assets/actionIcons/statusstruken.svg";
import StatusWaitingIcon from "@/assets/actionIcons/statuswaiting.svg";
import { NivaFranTill } from "@/types/anmalan";
import StatusRemissSkickadIcon from "@/assets/actionIcons/statusremissskickad.svg";
import StatusKallelseEjSkapadIcon from "@/assets/actionIcons/status_kallelse_ej_skapad.svg";
import StatusKallelseSkapadIcon from "@/assets/actionIcons/status_kallelse_skapad.svg";
import StatusKallelseSkickadIcon from "@/assets/actionIcons/status_kallelse_skickad.svg";
import StatusKallelseUtskrivenIcon from "@/assets/actionIcons/status_kallelse_utskriven.svg";

export const anmalanStatusIcons = {
    "Att hantera": StatusAttHanteraIcon,
    "Väntar på preanestesibedömning": StatusPreanestesibedomningIcon,
    "Preanestesibedömning genomförd": StatusPreanestesibedomningIcon,
    "Prioriterad preanestesibedömning": StatusPrioPreanestesibedomningIcon,
    "Preanestesibedömning prio genomförd": StatusPrioPreanestesibedomningIcon,
    "Väntar på viktnedgång": StatusWaitingIcon,
    "Väntar på rökstopp": StatusWaitingIcon,
    "Väntar på prover/undersökning": StatusWaitingIcon,
    "Offertförfrågan skickad": StatusOffertforfraganskickadIcon,
    "Offertförfrågan ej skickad": StatusOffertforfraganEjskickadIcon,
    "Betalningsförbindelse skickad": StatusBetalningsForbindelse,
    "Väntar på hälsodeklaration": StatusVantarPaHalso,
    "Klar för operationsbokning": StatusKlaropIcon,
    "Patientvald väntan": StatusAvvaktanIcon,
    "Medicinsk väntan": StatusAvvaktanIcon,
    "Administrativ väntan": StatusAvvaktanIcon,
    Bokad: StatusBokadIcon,
    Avbokad: StatusAvbokadIcon,
    Struken: StatusStrukenIcon,
    Genomförd: StatusGenomfordIcon,
    Pågående: StatusPagaendeIcon,
    Signerad: StatusSigneradIcon,
    Skickad: StatusRemissSkickadIcon,
};

export const preanestesiStatusIcons = {
    "Att göra": StatusAttGoraIcon,
    Påbörjad: StatusKompletteringKravsIcon,
    Godkänd: StatusGodkandIcon,
    "Komplettering krävs": StatusKompletteringKravsIcon,
    "Komplettering utförd": StatusKompletteringUtfordIcon,
    "Ej godkänd": StatusEjGodkandIcon,
    Återkallad: StatusAterkalladIcon,
    Utgången: StatusUtgangenIcon,
    "Godkänd i primärsystem": StatusGodkandIcon,
};

export const kallelseStatusIcons = {
    "Ej skapad": StatusKallelseEjSkapadIcon,
    "Kallelse skapad": StatusKallelseSkapadIcon,
    "Kallelse skickad": StatusKallelseSkickadIcon,
    "Kallelse utskriven": StatusKallelseUtskrivenIcon,
};

// Avgör när en operation är låst till att bokas som preliminär, och alltså inte går att boka skarpt
// - om följande statusar gäller, eller om anmälan saknar huvudoperatör.
export const preliminarbokningLocked = ({ status, huvudoperator }: { status: string; huvudoperator: string }) => {
    return (
        [
            "Att hantera",
            "Väntar på viktnedgång",
            "Väntar på rökstopp",
            "Väntar på prover/undersökning",
            "Offertförfrågan skickad",
            "Offertförfrågan ej skickad",
            "Betalningsförbindelse skickad",
            "Väntar på hälsodeklaration",
            "Patientvald väntan",
            "Medicinsk väntan",
            "Administrativ väntan",
        ].includes(status) || !huvudoperator
    );
};

/**
 * Returnera option-värdet utefter två möjliga strukturer.
 * Antingen enbart värdet (string | number) eller objekt: {label: string, value: string}
 *
 * @param optionName
 * @returns
 */
export const getSelectOptionValue = (optionName: any) => {
    if (!optionName) {
        return null;
    }
    if (typeof optionName === "string" || typeof optionName === "number") {
        return optionName;
    } else {
        return optionName.value;
    }
};

export const calculateAntalNivaer = (model?: NivaFranTill[]) => {
    if (!model) {
        return undefined;
    }

    const nums = [];
    for (const niva of model) {
        const nivaFranNum = getSelectOptionValue(niva?.fran) ?? 0;
        const nivaTillNum = getSelectOptionValue(niva?.till) ?? 0;
        if (Number(nivaFranNum) <= 0 || Number(nivaTillNum) <= 0) {
            continue;
        } else {
            nums.push(Number(nivaTillNum) - Number(nivaFranNum));
        }
    }
    const sum = nums.reduce((sum, current) => sum + current, 0);
    return sum === 0 ? "-" : sum;
};

//TODO: inför typer efter TS 5.4 uppgradering
export const collectNestedFieldErrors = (fieldKey: string, value: any) => {
    // keys förväntas vara nummersträngar - kontrollera första key
    const isIndexKey = Number.isInteger(parseInt(Object.keys(value)[0], 10));
    if (!isIndexKey) {
        return {};
    }
    const errors: any = {};
    Object.keys(value).forEach((indexKey) => {
        if (isNonEmptyObject(value[indexKey])) {
            Object.keys(value[indexKey]).forEach((subFieldKey) => {
                // skapa vue formulate key-namn för repeater/group-fält
                errors[`${fieldKey}.${indexKey}.${subFieldKey}`] = value[indexKey][subFieldKey];
            });
        } else {
            // om datan kommer i inkompatibelt format för nested fält: som fallback sätt felet på gruppfältet
            errors[fieldKey] = value[indexKey];
        }
    });
    return errors;
};

/** (TODO: inför typer efter TS 5.4 uppgradering)
 * 
 * Samla felmeddelanden från datarespons. För groups/repeaterfält, skapa vue-formulate anpassade key-namn
 * 
 * Resulterande struktur:
 * const result = {
     fieldName: ['msg1','msg2'],
     fieldName2: 'msg1',
    'grouprepeatername.index.fieldname': ['error msg']
} };
 * @param data
 * @returns
 */
export const collectErrors = (data: any) => {
    if (!isNonEmptyObject(data)) {
        return [];
    }
    let errorMessages: any = {};
    Object.keys(data).forEach((key) => {
        if (isNonEmptyObject(data[key])) {
            errorMessages = { ...errorMessages, ...collectNestedFieldErrors(key, data[key]) };
        } else {
            errorMessages[key] = data[key];
        }
    });
    return errorMessages;
};

export const isNonEmptyObject = (value: any): value is Record<string, unknown> => {
    return (
        value !== null &&
        typeof value === "object" &&
        !Array.isArray(value) && // om du inte vill räkna arrays som objekt
        Object.keys(value).length > 0
    );
};

/**
 * Få första element som har vue-formulate-valideringsfel
 * @returns HTMLElement | null
 */
export const getFirstElementHavingError = (): HTMLElement | null => {
    return document.querySelector(".formulate-input-error, .formulate-form-errors");
};

export const scrollToElement = (element: HTMLElement | null = null) => {
    if (element) {
        element.scrollIntoView({
            inline: "center",
            block: "center",
            behavior: "smooth",
        });
    }
};

export const groupErrorsByProperty = (data: any[]) => {
    return data.reduce((acc, obj) => {
        const key = Object.keys(obj)[0];

        acc[key] ??= [];
        acc[key].push(obj[key]);

        return acc;
    }, {});
};
